import { NewOrderService as service } from './new-order.service';
import * as types from './new-order.service.types';

export { service, types };
